import { Theme } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { COLORS } from "../../../constants";
import { Breakpoints, SxProps } from "@mui/system";

/**
 * styles for card action component
 */
export const cardActionStylesFn = ({
  disabled,
}: {
  disabled?: boolean;
}): SxProps<Theme> => ({
  border: ["none", "21px"],
  ".MuiCardActionArea-focusHighlight": {
    ...(!disabled ? { background: "none" } : {}),
  },
  ...(disabled ? { cursor: "not-allowed" } : {}),
});

interface StyleProps {
  borderColor?: string;
  hasHoverBg?: boolean;
  variant?: string;
  elevation?: number;
  disabled?: boolean;
  selected?: boolean;
  dragged?: boolean;
  breakpoints: Breakpoints;
}

/**
 * styles added per custom rules outside of MUI Card
 */
const customCardStyleObject = {
  dragged: {
    backgroundColor: (theme: Theme): string =>
      `${lighten(theme.palette.primary.main, 0.92)}`,
  },
  selected: {
    backgroundColor: (theme: Theme): string =>
      `${lighten(theme.palette.primary.main, 0.92)}`,
  },
  disabled: {
    border: `solid 1px ${COLORS.P_OUTLINE}`,
    cursor: "not-allowed",
  },
};

/**
 * main card styles
 */
export const cardStylesFn = ({
  borderColor,
  variant,
  elevation,
  hasHoverBg,
  disabled,
  selected,
  breakpoints,
  dragged,
}: StyleProps): SxProps<Theme> => ({
  border: variant === "outlined" ? `1px solid ${borderColor}` : "inherit",
  // dont have full list of elevations, so preserving material 24 and adding 99 for QA
  ...(elevation === 24 && {
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  }),
  "&::selection": {
    backgroundColor: "primary.main",
  },
  [breakpoints.down("sm")]: {
    border: "none",
    borderRadius: "0px",
    borderLeft: variant === "outlined" ? `2px solid ${borderColor}` : "inherit",
  },
  [breakpoints.up("sm")]: {
    "&:hover": {
      backgroundColor: (theme) =>
        !disabled && hasHoverBg
          ? `${lighten(theme.palette.primary.main, 0.96)}`
          : "inherit",
    },
  },
  ...(dragged ? customCardStyleObject.dragged : {}),
  ...(disabled ? customCardStyleObject.disabled : {}),
  ...(selected ? customCardStyleObject.selected : {}),
});
